/**
 * Manual toasts + helpers (admin / investor / asset owner).
 * Most API messages are shown automatically via authApi baseQuery → appSlice → FloatingAlerts.
 *
 * import { toast, extractApiMessage, withApiToast } from "./components/common/AppToast";
 */
import { store } from "../../redux/store";
import {
  successAlert,
  errorAlert,
  warningAlert,
  infoAlert,
} from "../../redux/Reducers/appSlice";
import { extractApiMessage as extractApiMessageUtil } from "../../utils/extractApiMessage";

export { extractApiMessageUtil as extractApiMessage };

export const toast = {
  success: (message) =>
    store.dispatch(successAlert({ message: String(message ?? "") })),
  error: (message) =>
    store.dispatch(errorAlert({ message: String(message ?? "") })),
  warning: (message) =>
    store.dispatch(warningAlert({ message: String(message ?? "") })),
  info: (message) =>
    store.dispatch(infoAlert({ message: String(message ?? "") })),
};

export async function withApiToast(promise, options = {}) {
  const {
    successMessage,
    errorMessage,
    skipSuccess = false,
    skipError = false,
  } = options;
  try {
    const data = await promise;
    if (!skipSuccess) {
      const msg =
        successMessage ??
        (data && typeof data === "object" && data.message
          ? String(data.message)
          : null);
      if (msg) toast.success(msg);
    }
    return data;
  } catch (e) {
    if (!skipError) {
      toast.error(errorMessage ?? extractApiMessageUtil(e));
    }
    throw e;
  }
}
